import { useContext, useMemo } from 'react';
import { ChatViewType, ChatViewTypeContext } from '@trinity/chat-components/components/BrandInsights/context';

export const useIsFullPageChat = () => {
  const view = useContext(ChatViewTypeContext);

  return useMemo(() => {
    return view === ChatViewType.Page;
  }, [view]);
};